<template>
  <div>
    <validation-observer ref="validator">
      <div class="d-flex">
        <section-title
          has-line
          content="Configuración por año académico"
          :class="isMobile ? 'section-title' : ''"
        />
      </div>
      <div
        v-if="showBtnAddConfig"
        :class="[
          'd-flex bg-secondary-13 justify-content-center',
          { 'p-3': !isMobile, 'py-3': isMobile },
        ]"
      >
        <box-icon-button
          :icon="'fas fa-file-plus'"
          title="Presione aquí para añadir configuración"
          :class="['margin-auto', { 'w-49': !isMobile }]"
          @click="addConfig"
        />
      </div>
      <div v-show="isModeEdition" class="mb-4">
        <div class="row">
          <div class="col-12 col-md-4">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="sc-academicYear"
                v-model="model.year"
                :disabled="isUpdate"
                :options="yearsFiltered"
                label="Año Académico:"
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="description"
                placeholder="Seleccione"
                :custom-error-msg="resources['24008']"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="sc-region"
                v-model="model.region"
                :options="collections.regions"
                label="Región:"
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :custom-error-msg="resources['24009']"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="sc-center"
                v-model="model.center"
                :options="collections.centers"
                label="Centro:"
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="name"
                :custom-error-msg="resources['24010']"
                placeholder="Seleccione"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
        </div>
        <div :class="['row', { 'mt-3': !isMobile }]">
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="sc-district"
                v-model="model.district"
                :options="collections.districts"
                label="Distrito:"
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                :custom-error-msg="resources['24011']"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="sc-municipalities"
                v-model="model.municipality"
                :options="collections.municipalities"
                label="Municipio:"
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="name"
                :custom-error-msg="resources['24012']"
                placeholder="Seleccione"
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <ValidationProvider
              v-slot="{ errors }"
              rules="valid_selection|required"
            >
              <custom-drop-down
                id="sc-educational-environment"
                v-model="model.educationalEnvironmentType"
                placeholder="Seleccione"
                :options="collections.educationalEnvironmentTypes"
                label="Tipo de Ambiente Educativo:"
                custom-error-msg="Favor de seleccionar el Ambiente Educativo."
                :regular-label="isMobile"
                fieldkey="id"
                fieldname="name"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>
          <div :class="['col-12 col-md-4', { 'mt-3': isMobile }]">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="levelId"
                v-model="model.schoolLevelType"
                :options="collections.schoolLevelTypes"
                label="Nivel:"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="Favor de seleccionar el Nivel."
                :regular-label="isMobile"
                :error="errors[0]"
              />
            </ValidationProvider>
          </div>

          <div class="col-12 col-md-4 mt-3">
            <label>
              ¿Cuenta con transportación Regular?
            </label>
            <custom-radio
              v-model="model.hasRegularTransport"
              is-inline
              name="transportation"
              customErrorMsg=""
              :options="defaultOptions"
            />
          </div>
          <div :class="['col-12 col-md-12 mt-3', { 'my-4': isMobile }]">
            <div class="d-flex justify-content-end h-100 align-items-end">
              <action-button
                class="btn-mobile mr-3 px-3"
                variant="outline-danger"
                i="fas fa-times-circle"
                text="Cancelar"
                @click="cancelAddEdit"
              />
              <action-button
                class="btn-mobile px-3"
                variant="success"
                i="fas fa-save"
                text="Guardar"
                @click="addEditRequest"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="showBtnAdd" class="d-flex justify-content-end">
        <action-button
          class="btn-mobile px-3"
          variant="success"
          i="fas fa-file-plus"
          text="Añadir"
          @click="addConfig"
        />
      </div>
      <configuration-row
        v-for="(row, idx) in rowsOrdered"
        :key="idx"
        :resources="resources"
        :value="row"
        @on-edit="editConfig"
        @on-delete-flag="updateDeleteFlag"
      />
    </validation-observer>
  </div>
</template>

<script>
import { BoxIconButton } from '@/components/pei/shared';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomRadio from 'custom-radio';
import { ActionButton } from '@/components/common';
import CustomInput from 'CustomInput';
import ConfigurationRow from './ConfigurationRow.vue';
import mixAlert from '@/mixin/alert.mixin';
import objectToFormData from 'object-to-formdata';
import { extend } from 'vee-validate';
import resourcesService from '@/services/resources.js';
import locationApi from '@/modules/common/location.api';
import schoolApi from '@/modules/school-management/api';
import api from '@/modules/student-evaluation-request-managment/api';
import schoolManagementApi from '@/modules/operation-school-management/api';

extend('valid_selection', {
  validate: (value) => {
    return (
      value &&
      ((value.id !== null && value.id !== undefined && value.id !== '') ||
        (value.name !== null && value.name !== undefined && value.name !== ''))
    );
  },
  message: 'Favor de seleccionar una opción válida.',
});

export default {
  name: 'ConfigurationByAcademicYear',
  mixins: [mixAlert],
  components: {
    SectionTitle,
    BoxIconButton,
    CustomDropDown,
    CustomRadio,
    ActionButton,
    CustomInput,
    ConfigurationRow,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    locationSchoolId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      collections: {
        years: [],
        regions: [],
        centers: [],
        districts: [],
        municipalities: [],
        educationalEnvironmentTypes: [],
        schoolLevelTypes: [],
      },
      model: {
        year: null,
        region: null,
        center: null,
        district: null,
        municipality: null,
        educationalEnvironmentType: null,
        schoolLevelType: null,
        hasRegularTransport: true, // by default
      },
      defaultOptions: [
        {
          id: 1,
          name: 'trans-rbnt',
          value: true,
          label: 'Sí',
          check: false,
        },
        {
          id: 2,
          name: 'bill-discussion-rbnt',
          value: false,
          label: 'No',
          check: false,
        },
      ],
      selectedModel: {},
      resources: [],
      isModeEdition: false,
      isUpdate: false,
      canReset: false,
    };
  },
  computed: {
    yearsFiltered() {
      return this.collections.years.filter(
        (year) => !this.rows?.some((row) => row?.academicYearId == year?.id)
      );
    },
    rowsOrdered() {
      return (this.rows || []).sort(
        (a, b) => b.academicYearId - a.academicYearId
      );
    },
    userCanAdd() {
      return this.$store.getters.HasPermission('school.yearconfig.add');
    },
    showBtnAddConfig() {
      return this.rows?.length == 0 && !this.isModeEdition && this.userCanAdd;
    },
    showBtnAdd() {
      return !this.showBtnAddConfig && !this.isModeEdition && this.userCanAdd;
    },
    builtModel() {
      return {
        academicYearId: this.model.year?.id,
        academicYearName: this.model.year?.description,
        districtId: this.model.district?.id,
        districtName: this.model.district?.name,
        regionId: this.model.region?.id,
        regionName: this.model.region?.name,
        municipalityId: this.model.municipality?.id,
        municipalityName: this.model.municipality?.name,
        centerId: this.model.center?.id,
        centerName: this.model.center?.name,
        deleteFlag: this.model.deleteFlag || '0',
        locationSchoolId: this.locationSchoolId,
        educationalEnvironmentTypeId: this.model.educationalEnvironmentType.id,
        educationalEnvironmentTypeName: this.model.educationalEnvironmentType
          .name,
        schoolLevelTypeId: this.model.schoolLevelType?.id,
        schoolLevelTypeName: this.model.schoolLevelType?.name,
        hasRegularTransport: this.model.hasRegularTransport,
        opened: this.model.opened,
      };
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  async created() {
    api.getAcademicYear().then((data) => {
      this.collections.years = data;
    });

    this.collections.educationalEnvironmentTypes = (
      await schoolManagementApi.getSchoolEducationalEnvironmentTypes()
    ).data;

    this.collections.schoolLevelTypes = (
      await schoolManagementApi.getSchoolLevelTypes()
    ).data;

    this.loadResources();
  },
  methods: {
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '24008',
        '24009',
        '24010',
        '24011',
        '24012',
        '0649',
        '24013',
        '24014',
      ]);
    },
    addConfig() {
      this.isModeEdition = true;
      this.canReset = true;
      this.isUpdate = false;
      this.model.hasRegularTransport = true;
    },
    async cancelAddEdit() {
      this.isModeEdition = false;
      this.resetModel();
      await this.$refs.validator.reset();
    },
    resetModel() {
      Object.keys(this.model).forEach((prop) => {
        this.model[prop] = null;
      });
    },
    async addEditRequest() {
      const isValid = await this.$refs.validator.validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }

      if (this.isUpdate) {
        const paramsToSend = {
          oldLocationSchoolAcademicYearDto: this.selectedModel,
          newLocationSchoolAcademicYearDto: this.builtModel,
        };
        const formData = objectToFormData(paramsToSend, { indices: true });

        schoolApi
          .updateConfigYear(formData)
          .then(() => {
            let index = this.rows.findIndex(
              (row) => row.academicYearId == this.selectedModel.academicYearId
            );
            this.$set(this.rows, index, this.builtModel);
            this.cancelAddEdit();
            this.ShowToast('', this.resources['0649'], this.toastType.Success);
          })
          .catch((error) => {
            this.ShowToast('', error.message, this.toastType.Error);
          });
      } else {
        schoolApi
          .saveConfigYear(this.builtModel)
          .then(() => {
            this.ShowToast('', this.resources['0649'], this.toastType.Success);
            this.rows.push(this.builtModel);
            this.cancelAddEdit();
            this.$forceUpdate();
          })
          .catch((error) => {
            this.ShowToast('', error.message, this.toastType.Error);
          });
      }
    },
    editConfig(model) {
      this.canReset = false;
      this.isModeEdition = true;
      this.isUpdate = true;
      this.model = { ...model };
      this.model.schoolLevelType = this.collections.schoolLevelTypes.find(
        (l) => l.id == this.model.schoolLevelType?.id
      );
      this.selectedModel = this.builtModel;
    },
    updateDeleteFlag(newDeleteFlag) {
      this.model.deleteFlag = newDeleteFlag;
    },
  },
  watch: {
    'model.year'(value) {
      if (this.canReset) this.model.region = null;

      if (value?.id) {
        locationApi
          .getRegions({
            academicYearId: value?.id,
          })
          .then((data) => (this.collections.regions = data));
      } else this.collections.regions = [];
    },
    'model.region'(value) {
      if (this.canReset) this.model.center = null;

      if (value?.id) {
        locationApi
          .getCenters({
            regionId: value?.id,
            academicYearId: this.model.year?.id,
          })
          .then((data) => (this.collections.centers = data));
      } else this.collections.centers = [];
    },
    'model.center'(value) {
      if (this.canReset) this.model.district = null;

      if (value?.id) {
        locationApi
          .getDistricts({
            regionId: this.model.region?.id,
            academicYearId: this.model.year?.id,
            centerId: value?.id,
          })
          .then((data) => (this.collections.districts = data));
      } else this.collections.districts = [];
    },
    'model.district'(value) {
      if (this.canReset) this.model.municipality = null;

      if (value?.id) {
        locationApi
          .getMunicipalities({
            regionId: this.model.region?.id,
            academicYearId: this.model.year?.id,
            centerId: this.model.center?.id,
            districtId: value?.id,
          })
          .then((data) => (this.collections.municipalities = data));
      } else this.collections.municipalities = [];

      this.canReset = true;
    },
  },
};
</script>
<style scoped>
@media only screen and (max-width: 375px) {
  ::v-deep .regular {
    font-size: 12px !important;
    font-weight: normal !important;
  }

  .btn-mobile {
    width: 50%;
  }

  ::v-deep .tag-badge-title-info {
    font-size: 12px !important;
  }

  .section-title {
    width: 100% !important;
    margin-bottom: 3px !important;
  }

  ::v-deep .bg-light-white {
    padding: 2px 20px !important;
    font-size: 12px !important;
  }

  ::v-deep .fa-file-plus {
    padding-right: 5px !important;
  }
}
</style>
